'use es6';

export const betaLocales = {
  'zh-tw': {
    language: 'zh',
    beta: true,
    defaultLocale: 'zh-tw',
    availableLocale: ['zh-tw']
  },
  'no-no': {
    language: 'no',
    beta: true,
    defaultLocale: 'no-no',
    availableLocale: ['no-no']
  },
  da: {
    language: 'da',
    beta: true,
    defaultLocale: 'da',
    availableLocale: ['da']
  }
};
export const betaPublicLocales = {
  'pt-pt': {
    language: 'pt-pt',
    beta: true,
    defaultLocale: 'pt-pt',
    availableLocale: ['pt-pt']
  }
};